import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactForm.css';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // EmailJS configuration
    // IMPORTANT: You need to set up EmailJS to enable email functionality
    // 1. Create a free account at https://www.emailjs.com/
    // 2. Create an Email Service (Gmail, Outlook, etc.)
    // 3. Create an Email Template with variables: {{from_name}}, {{from_email}}, {{phone}}, {{message}}
    // 4. Get your Public Key from Account > General
    // 5. Replace the values below with your actual EmailJS credentials
    const serviceId = 'service_f0bxk6g'; // Replace with your Service ID
    const templateId = 'template_rpepyuo'; // Replace with your Template ID
    // const publicKey = 'YOUR_PUBLIC_KEY'; // Replace with your Public Key

    try {
      // Send email using EmailJS
      await emailjs.send(
        serviceId,
        templateId,
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message
        },
        "MAHrUx7EcvmSKnoLu"
      );

      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error('EmailJS error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="name">Full Name *</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="Enter your full name"
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">Email Address *</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Enter your email address"
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone">Phone Number</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Enter your phone number"
        />
      </div>

      <div className="form-group">
        <label htmlFor="message">Message *</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          rows="5"
          placeholder="Tell us how we can help you..."
        />
      </div>

      {submitStatus === 'success' && (
        <div className="alert alert-success">
          ✓ Thank you! Your message has been sent successfully. We'll get back to you soon.
        </div>
      )}

      {submitStatus === 'warning' && (
        <div className="alert alert-success">
          Our email service is down temporarily, please reach out to us directly
        </div>
      )}

      {submitStatus === 'error' && (
        <div className="alert alert-error">
          ✗ Sorry, there was an error sending your message. Please try again or contact us directly.
        </div>
      )}

      <button type="submit" className="btn btn-submit" disabled={isSubmitting}>
        {isSubmitting ? 'Sending...' : 'Send Message'}
        <img src="/assets/send.svg" alt="Send" className="send-icon" />
      </button>
    </form>
  );
};

export default ContactForm;

